import { Routes } from '@angular/router';
import { HardshipRequiredDocsComponent } from './hardship-required-docs/hardship-required-docs.component';
import { HardshipIntroComponent } from './hardship-intro/hardship-intro.component';
import { HardshipRequestDetailsComponent } from './hardship-request-details/hardship-request-details.component';
import { hardshipBaseGuardCanMatch, hardshipDocsGuardCanMatch } from './hardship.guard';

export const hardshipRoutes: Routes = [
  {
    path: 'hardship',
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'intro'
      },
      {
        path: 'intro',
        component: HardshipIntroComponent,
        canMatch: [hardshipBaseGuardCanMatch]
      },
      {
        path: 'review',
        component: HardshipRequestDetailsComponent,
        canMatch: [hardshipDocsGuardCanMatch]
      },
      {
        path: 'additional-documents',
        component: HardshipRequiredDocsComponent,
        canMatch: [hardshipDocsGuardCanMatch],
        data: {
          routeAction: 'submit'
        }
      },
      {
        path: 'documents',
        component: HardshipRequiredDocsComponent,
        canMatch: [hardshipDocsGuardCanMatch],
        data: {
          routeAction: 'confirm-request'
        }
      }
    ],
  },
];
